const CALL_TYPEFORM_LINK = "https://bit.ly/doola-free-consultation";

export const LINK_SCHEDULE_A_CALL = (hiddenVariable: string | undefined) =>
  `${CALL_TYPEFORM_LINK}${
    hiddenVariable ? `#everflow_partner=${hiddenVariable}` : ""
  }`;
